<template>
  <top-nav  />
  <auth-sign-up></auth-sign-up>
  <router-view />
</template>

<script>
// @ is an alias to /src
import AuthSignUp from "@/components/AuthSignUp.vue";
import TopNav from "../components/nav/TopNav.vue"

export default {
  components: {
    AuthSignUp,
    TopNav,
  },
};
</script>
